import React, { useState, useEffect } from "react";
import {
  Box,
  Container,
  Typography,
  Grid,
  List,
  ListItem,
  Link,
  Divider,
} from "@mui/material";

const Info = () => {
  const [articles, setArticles] = useState([]);

  useEffect(() => {
    const fetchArticles = async () => {
      let page = 1;
      const maxPages = 5;
      const allArticles = [];
      const corsProxyKey = process.env.REACT_APP_CORSPROXY_KEY;

      if (!corsProxyKey) {
        // eslint-disable-next-line no-console
        console.warn(
          "REACT_APP_CORSPROXY_KEY が未設定のため、noteの記事を取得できません。.env.local を確認してください。",
        );
        return;
      }

      try {
        while (page <= maxPages) {
          const targetUrl = `https://note.com/api/v2/creators/youproduce_/contents?kind=note&page=${page}`;
          const res = await fetch(
            `https://corsproxy.io/?key=${corsProxyKey}&url=${encodeURIComponent(targetUrl)}`,
          );
          if (!res.ok) break;
          const json = await res.json();
          if (!json.data?.contents?.length) break;
          allArticles.push(...json.data.contents);
          page += 1;
        }

        allArticles.sort(
          (a, b) => new Date(b.publishAt || 0) - new Date(a.publishAt || 0),
        );

        setArticles(allArticles.slice(0, 3));
      } catch {
        // error
      }
    };
    fetchArticles();
  }, []);

  const formatDate = (article) => {
    const date = new Date(article.publishAt);
    if (isNaN(date)) return "日付不明";
    return `${date.getFullYear()}年${date.getMonth() + 1}月${date.getDate()}日`;
  };

  return (
    <Box
      id="info"
      sx={{
        position: "absolute",
        left: "50%",
        top: { xs: "calc(100% - 140px)", md: "calc(100% - 180px)" },
        transform: "translate(-50%, 0)",
        width: { xs: "90%", md: "63%" },
        bgcolor: "#fff",
        borderRadius: 3,
        boxShadow: "0 4px 12px rgba(0,0,0,0.08)",
        zIndex: 10,
      }}
    >
      <Container sx={{ p: { xs: 2, md: 6 } }}>
        <Grid container spacing={{ xs: 2, md: 4 }}>
          <Grid
            item
            xs={12}
            md={3}
            sx={{
              textAlign: { xs: "center", md: "left" },
              display: "flex",
              flexDirection: "column",
              justifyContent: "center",
              pr: { xs: 0, md: 5 },
            }}
          >
            <Typography
              variant="body2"
              sx={{
                color: "gray",
                fontSize: { xs: 12, md: 14 },
                mb: 1,
              }}
            >
              Info
            </Typography>
            <Typography
              variant="h4"
              sx={{
                fontWeight: "bold",
                color: "red",
                fontSize: { xs: 20, md: 26 },
              }}
            >
              お知らせ
            </Typography>
            <Box
              sx={{
                width: 32,
                height: 2,
                bgcolor: "navy",
                mt: 1,
                mx: { xs: "auto", md: "0" },
              }}
            />
          </Grid>
          <Grid item xs={12} md={9} sx={{ mt: { xs: 2, md: 1 } }}>
            <List disablePadding>
              {articles.length === 0 && (
                <Typography sx={{ color: "gray" }}>
                  お知らせ記事がありません
                </Typography>
              )}
              {articles.map((article, i) => (
                <React.Fragment key={article.key || article.id}>
                  <ListItem
                    sx={{
                      px: 0,
                      py: { xs: 1, md: 2 },
                      display: "flex",
                      alignItems: "center",
                      height: { xs: "auto", md: 70 },
                    }}
                  >
                    <Typography
                      sx={{
                        color: "#777",
                        minWidth: { xs: 100, md: 130 },
                        fontSize: { xs: 12, md: 14 },
                        mr: 2,
                      }}
                    >
                      {formatDate(article)}
                    </Typography>
                    <Link
                      href={`https://note.com/${article.user.urlname}/n/${article.key}`}
                      target="_blank"
                      rel="noopener"
                      sx={{
                        display: "flex",
                        alignItems: "center",
                        color: "#000",
                        textDecoration: "none",
                        overflow: "hidden",
                        textOverflow: "ellipsis",
                        whiteSpace: "nowrap",
                        flex: 1,
                        fontSize: { xs: 13, md: 14 },
                        position: "relative",
                        paddingBottom: "4px",
                        "&::after": {
                          content: '""',
                          position: "absolute",
                          width: "0%",
                          height: "1px",
                          bottom: "0px",
                          left: "0",
                          backgroundColor: "#E40614",
                          transition: "width 0.3s ease-in-out",
                        },
                        "&:hover::after": {
                          width: "100%",
                        },
                      }}
                    >
                      {article.name}
                    </Link>
                  </ListItem>
                  {i < articles.length - 1 && <Divider />}
                </React.Fragment>
              ))}
            </List>
            <Box sx={{ display: "flex", justifyContent: "flex-end", mt: 2 }}>
              <Link
                href="https://note.com/youproduce_"
                target="_blank"
                rel="noopener"
                sx={{
                  color: "#E40614",
                  fontSize: { xs: 13, md: 14 },
                  fontWeight: "bold",
                  textDecoration: "none",
                  "&:hover": {
                    textDecoration: "underline",
                  },
                }}
              >
                view more
              </Link>
            </Box>
          </Grid>
        </Grid>
      </Container>
    </Box>
  );
};

export default Info;
